// extracted by mini-css-extract-plugin
export var brand = "_l-9";
export var button = "_l-0";
export var chevron = "_l-v";
export var chevronButton = "_l-w";
export var content = "_l-n";
export var danger = "_l-g";
export var dangerOutlined = "_l-h";
export var dark = "_l-l";
export var darkTheme = "_l-c";
export var extraSmall = "_l-4";
export var fullWidth = "_l-8";
export var ghost = "_l-d";
export var gray = "_l-t";
export var icon = "_l-p";
export var iconButton = "_l-s";
export var iconButtonBorder = "_l-x";
export var iconButtonBorderDark = "_l-y";
export var iconButtonBorderLight = "_l-z";
export var iconLeft = "_l-q";
export var iconRight = "_l-r";
export var large = "_l-1";
export var light = "_l-m";
export var medium = "_l-2";
export var micro = "_l-5";
export var nano = "_l-7";
export var outlined = "_l-k";
export var pending = "_l-a";
export var primary = "_l-i";
export var shadow = "_l-o";
export var small = "_l-3";
export var solidLight = "_l-e";
export var solidLightBrand = "_l-f";
export var spinner = "_l-u";
export var transparent = "_l-j";
export var warning = "_l-b";
export var wideNano = "_l-6";